module.exports = __webpack_public_path__ + "img/r-cb-off1.c782ff31.gif";